module.exports = __webpack_public_path__ + "static/06-205b1136dce4f7193a72d35e59a7efdf.jpg";